
<div id="imgFullscreen">
    <img v-if="url" :src="url" alt="" style="width: 100%"/>
</div>
